import React from 'react';
import { Link } from 'react-router-dom';

function mostrarOrden({ orden }) {
  const fecha = orden.fecha?.toDate?.().toLocaleString('es-GT') ?? 'Sin fecha';
  const productos = orden.pedido ?? [];

  return (
    <div className="w-full flex justify-center px-2">
      <div className="w-full max-w-4xl border-b border-gray-200 py-4 hover:bg-gray-50 transition-all">

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4">

          {/* Columna 1: Info General */}
          <div className="flex-1">
            <p className="text-sm text-gray-500">
              Boleta: <span className="font-medium text-blue-700">#{orden.boleta}</span>
            </p>
            <p className="text-sm text-gray-500">
              Fecha: <span className="font-medium">{fecha}</span>
            </p>
          </div>

          {/* Columna 2: Productos */}
          <div className="flex-1">
            <p className="text-sm font-semibold text-gray-700">Productos:</p>
            <ul className="text-sm text-gray-600 list-disc pl-5">
              {productos.map((producto, index) => (
                <li key={index}>
                  {producto.cantidad} x {producto.nombre} - Q{producto.subtotal?.toFixed(2)}
                </li>
              ))}
            </ul>
          </div>

          {/* Columna 3: Total y acción */}
          <div className="flex flex-col items-start sm:items-end">
            <p className="text-green-700 font-bold text-lg mb-2">
              Total: Q{orden.total?.toFixed(2)}
            </p>
            <Link to={`/orden/${orden.id}`}>
              <button className="bg-blue-700 hover:bg-blue-600 text-white uppercase text-xs px-4 py-2 rounded-md">
                Ver Detalle
              </button>
            </Link>
          </div>

        </div>

      </div>
    </div>
  );
}

export default mostrarOrden;
